import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-bag',
  templateUrl: './bag.component.html',
  styleUrls: ['./bag.component.scss'],
  imports: [MatIconModule],
})
export class BagComponent {
  @Input() count = 0;
  constructor() {}
}
